import { render } from "./SideNavHeader.vue?vue&type=template&id=4bc7dfc0&scoped=true"
import script from "./SideNavHeader.vue?vue&type=script&lang=js"
export * from "./SideNavHeader.vue?vue&type=script&lang=js"

import "./SideNavHeader.vue?vue&type=style&index=0&id=4bc7dfc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc7dfc0"]])

export default __exports__